import React, { FunctionComponent, useEffect } from "react";
import { Box } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import BusinessComponent from "components/Business";
import { getThunk } from "actions/businesses/BusinessesActions";
import { useDispatch } from "react-redux";

interface Props {

}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      background: "#fff"
    },
  })
);

export const Business: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <BusinessComponent />
    </Box>
  );
};

export default Business;

